import React from 'react';
import styles from './MealPlanPopup.module.css';
import {
  computeBmi,
  formatDate,
  formatMeasure,
  formatNumber,
  getValue,
  sortByDateDesc,
} from '../../pages/appointment/components/bodyMeasurements/bodyMeasurementsMath';

/**
 * Uma linha discreta com a última avaliação do módulo "Medidas corporais"
 * (data, peso, altura e IMC), para o profissional montar o plano sem sair
 * do popup. Some quando não há avaliação.
 */
const BodyMeasurementsHint = ({ bodyMeasurements }) => {
  const list = Array.isArray(bodyMeasurements) ? bodyMeasurements : [];
  const latest = sortByDateDesc(list)[0] || null;
  if (!latest) return null;

  const weight = getValue(latest, 'weight');
  const height = getValue(latest, 'height');
  const bmi = computeBmi(list, latest);
  if (weight === null && height === null) return null;

  const shownHeight = height !== null ? height : (bmi ? bmi.height : null);
  const parts = [`Última avaliação ${formatDate(latest.measuredAt)}`];
  if (weight !== null) parts.push(formatMeasure(weight, 'weight'));
  if (shownHeight !== null) parts.push(formatMeasure(shownHeight, 'height'));
  if (bmi && bmi.value !== null) parts.push(`IMC ${formatNumber(bmi.value, 1)}`);

  return <span className={styles.hint}>{parts.join(' · ')}</span>;
};

export default BodyMeasurementsHint;
